export const Language = {
  EN: 'en',
  RU: 'ru',
};

export const Languages = [
  { value: Language.EN, text: 'English' },
  { value: Language.RU, text: 'Русский' },
];
